import { createSlice } from '@reduxjs/toolkit';
import {
    HAIR_COLOR_NO_CHANGE,
    HAIR_STYLE_NO_CHANGE,
    HAIR_STYLE_NO_CHANGE_KEY,
    HAIR_COLOR_NO_CHANGE_KEY,
    NONE_GENDER,
    HAIRSTYLE_GENDER_FEMALE,
    HAIRSTYLE_LIST,
} from '../../config/dataConfig/FJHairstyleChangerDataConfig';

export const FJSliceHairstyleChanger = createSlice({
    name: 'hairstyleChanger',
    initialState: {
        tab: 0, // 0: 'female', 1: 'male', 2: 'color'
        // 用户人像
        peopleImageInfo: {},

        // 仅维护一份数据，切换tab会重置
        hairInfo: {
            hairColor: {
                key: HAIR_COLOR_NO_CHANGE_KEY,
                value: HAIR_COLOR_NO_CHANGE,
                filename: null,
            },
            gender: HAIRSTYLE_GENDER_FEMALE,
            male: {
                ...HAIRSTYLE_LIST.male[0].hairstyles[0],
            },
            female: {
                ...HAIRSTYLE_LIST.female[0].hairstyles[0],
            },
        },

        // 预设数据
        hairCutPresetData: {},
        hairColorPresetData: {},
    },
    reducers: {
        setTab(state, action) {
            state.tab = action.payload;
        },
        setPeopleImageInfo(state, action) {
            state.peopleImageInfo = action.payload;
        },
        setHairInfo(state, action) {
            state.hairInfo = { ...state.hairInfo, ...action.payload };
        },
        setHairCutPresetData(state, action) {
            state.hairCutPresetData = action.payload;
        },
        setHairColorPresetData(state, action) {
            state.hairColorPresetData = action.payload;
        },
        resetHairstyleChanger(state) {
            state.hairInfo = {
                hairColor: {
                    key: HAIR_COLOR_NO_CHANGE_KEY,
                    value: HAIR_COLOR_NO_CHANGE,
                    filename: null,
                },
                male: {
                    ...HAIRSTYLE_LIST.male[0].hairstyles[0],
                },
                female: {
                    ...HAIRSTYLE_LIST.female[0].hairstyles[0],
                },
                gender: HAIRSTYLE_GENDER_FEMALE,
            };
            state.peopleImageInfo = {};
            state.tab = 0;
        },
    },
});

export const {
    setTab,
    setPeopleImageInfo,
    setHairInfo,
    setHairCutPresetData,
    setHairColorPresetData,
    resetHairstyleChanger,
} = FJSliceHairstyleChanger.actions;

export default FJSliceHairstyleChanger.reducer;
